import { reactive, ref } from 'vue';
import { dispatchManualCollapse, maintainExpandMode } from './expandMode';
import type { ResultsViewEmit } from './types';

export function useResultsNavigation(emit: ResultsViewEmit) {
  const openSections = reactive({ vehiculo: false, conductor: false });
  const showPrivacyDialog = ref(false);

  const toggleSection = (section: 'vehiculo' | 'conductor'): void => {
    openSections[section] = !openSections[section];
  };

  const handleEditVehicle = (): void => {
    emit('editVehicle');
    maintainExpandMode();
  };

  const handleEditDriver = (): void => {
    emit('editDriver');
    maintainExpandMode();
  };

  const handleCloseResults = (): void => {
    dispatchManualCollapse();
    emit('editVehicle');
  };

  const handleOpenPrivacyDialog = (): void => {
    showPrivacyDialog.value = true;
    maintainExpandMode();
  };

  return {
    openSections,
    showPrivacyDialog,
    toggleSection,
    handleEditVehicle,
    handleEditDriver,
    handleCloseResults,
    handleOpenPrivacyDialog,
  };
}
